import React from "react";
import "./RevenueTable.scss";

const RevenueTable = ({ data }) => {
  return (
    <div className="revenue-table-container-regional">
      <table className="revenue-table">
        <thead className="revenue-table__header">
          <tr>
            <th className="frame-header-one">Regional</th>
            <th className="frame-header-second">Total Income</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item.region} className="revenue-table__row">
              <td>
                <span
                  className={`revenue-table__row-indicator revenue-table__row-indicator`}
                  style={{ backgroundColor: item.indicator }}
                ></span>
                {item.region}
              </td>
              <td
                className={`revenue-table__row-revenue ${
                  item.totalRevenue < 0
                    ? "revenue-table__row-revenue--negative"
                    : "revenue-table__row-revenue--positive"
                }`}
              >
                {item.totalRevenue < 0 ? (
                  <>
                    -$
                    {Math.abs(item.totalRevenue).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </>
                ) : (
                  <>
                    $
                    {item.totalRevenue.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RevenueTable;
